export default "__VITE_ASSET__Vy2uthhr__"